<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7 7.51456H4.49995L10.1 1.74822L8.69995 0.306641L0.699951 8.54426L8.69995 16.7819L10.1 15.3403L4.49995 9.57397H16.7V7.51456Z"/>
</svg>
